<main id="conteudo" class="report-shell" tabindex="-1">
  @if (busy()) {
  <div class="loading-overlay" role="status" aria-live="polite">
    <div class="spinner"></div>
    <p>
      @if (syncing() && syncProgress(); as progress) {
        Atualizando visitas: {{ progress.processed }} / {{ progress.total || '...' }} anúncios
      } @else {
        {{ syncing() ? 'Atualizando relatório pela API...' : 'Carregando relatório...' }}
      }
    </p>
  </div>
  }

  <header class="card report-hero">
    <div>
      <span class="eyebrow">Relatórios semanais</span>
      <h1>Relatório Executivo Tigrão</h1>
      <p>Versão automatizada dos PDFs antigos · {{ periodLabel() }}</p>
    </div>
    <div class="hero-actions no-print">
      <a class="btn btn-secondary" routerLink="/dashboard">Conciliação</a>
      <a class="btn btn-secondary" routerLink="/anuncios">Anúncios</a>
      <a class="btn btn-secondary" routerLink="/publicidade">Publicidade</a>
      <a class="btn btn-secondary" routerLink="/reputacao">Reputação</a>
      <button class="btn btn-secondary" type="button" (click)="logout()">Sair</button>
    </div>
  </header>

  <form class="card filters-card no-print" (ngSubmit)="loadReport()" aria-describedby="executive-filter-note">
    <label for="executive-start-date"><span>Data inicial</span><input id="executive-start-date" name="startDate" type="date" [value]="startDate()" (input)="startDate.set($any($event.target).value)" /></label>
    <label for="executive-end-date"><span>Data final</span><input id="executive-end-date" name="endDate" type="date" [value]="endDate()" (input)="endDate.set($any($event.target).value)" /></label>
    <button class="btn btn-primary" type="submit" [disabled]="busy()">Carregar do banco</button>
    <button class="btn btn-secondary" type="button" [disabled]="busy()" (click)="syncReport()">Atualizar pela API</button>
    <button class="btn btn-secondary" type="button" [disabled]="busy()" (click)="setMonth()">Mês atual</button>
    <button class="btn btn-secondary" type="button" (click)="printReport()">Imprimir</button>
    <p id="executive-filter-note">Carregar do banco é rápido. Atualizar pela API busca visitas por anúncio e deixa o diagnóstico mais próximo dos relatórios do painel ML.</p>
    @if (syncProgress(); as progress) {
    <p class="sync-progress">Atualizando visitas: {{ progress.processed }} de {{ progress.total || '...' }} anúncios conferidos.</p>
    }
  </form>

  @if (message()) { <section class="card info-card">{{ message() }}</section> }
  @if (error()) { <section class="card info-card error">{{ error() }}</section> }

  @if (report(); as report) {
  <section class="card section-card executive-summary">
    <span class="eyebrow">1. Visão geral</span>
    <h2>O que aconteceu no período</h2>
    <div class="kpi-grid">
      <article><span>Faturamento bruto</span><strong>{{ formatMoney(report.overview.grossRevenue) }}</strong></article>
      <article><span>Vendas/unidades</span><strong>{{ report.overview.soldQuantity }}</strong></article>
      <article><span>Visitas por item</span><strong>{{ report.overview.visitsTotal ?? 'Indisponível' }}</strong></article>
      <article><span>Conversão venda/visita</span><strong>{{ formatPercent(report.overview.conversionRate) }}</strong></article>
      <article><span>Cancelado</span><strong>{{ formatMoney(report.overview.cancelledAmount) }}</strong></article>
      <article><span>Recebido/caixa estimado</span><strong>{{ formatMoney(report.overview.receivedAmount) }}</strong></article>
      <article><span>Tarifas/custos</span><strong>{{ formatMoney(report.overview.feesAmount + report.overview.adsCost) }}</strong></article>
      <article><span>Resultado líquido</span><strong>{{ formatMoney(report.overview.netResult) }}</strong></article>
    </div>
  </section>

  <section class="card section-card">
    <span class="eyebrow">2. Alertas críticos</span>
    <h2>O que merece ação agora</h2>
    @if (report.actions.length > 0) {
    <div class="action-grid">
      @for (action of report.actions; track action.title) {
      <article class="action-card">
        <span>{{ action.priority }}</span>
        <strong>{{ action.title }}</strong>
        <p>{{ action.reason }}</p>
        <small>{{ action.nextStep }}</small>
      </article>
      }
    </div>
    } @else {
    <p class="muted">Sem alerta automático forte para este período. Atualize pela API para enriquecer com visitas.</p>
    }
  </section>

  <section class="card section-card two-columns">
    <div>
      <span class="eyebrow">3. Anúncios que funcionam</span>
      <h2>Manter e ampliar</h2>
      <table>
        <caption class="visually-hidden">Anúncios que funcionam e devem ser mantidos ou ampliados</caption>
        <thead><tr><th scope="col">Anúncio</th><th scope="col">Vendas</th><th scope="col">Faturou</th><th scope="col">Conv.</th></tr></thead>
        <tbody>
          @for (item of report.listings.workingListings; track item.itemId) {
          <tr><td>{{ item.title }}</td><td>{{ item.soldQuantityInPeriod }}</td><td>{{ formatMoney(item.grossRevenueInPeriod) }}</td><td>{{ formatPercent(item.conversionRate) }}</td></tr>
          }
        </tbody>
      </table>
    </div>
    <div>
      <span class="eyebrow">4. Tráfego desperdiçado</span>
      <h2>Visita sem venda</h2>
      <table>
        <caption class="visually-hidden">Anúncios com visitas sem venda</caption>
        <thead><tr><th scope="col">Anúncio</th><th scope="col">Visitas</th><th scope="col">Preço</th><th scope="col">Ação</th></tr></thead>
        <tbody>
          @for (item of report.listings.trafficWaste; track item.itemId) {
          <tr><td>{{ item.title }}</td><td>{{ item.visits }}</td><td>{{ formatMoney(item.price) }}</td><td>Revisar preço, descrição e compatibilidade</td></tr>
          }
        </tbody>
      </table>
    </div>
  </section>

  <section class="card section-card two-columns">
    <div>
      <span class="eyebrow">5. Qualidade dos anúncios</span>
      <h2>Texto, fotos e ficha técnica</h2>
      <p class="muted">{{ report.overview.listingsWithProblems }} anúncios com pontos de melhoria. {{ report.overview.badTextListings }} com texto estranho/mal escrito.</p>
      <table>
        <caption class="visually-hidden">Qualidade dos anúncios com problemas encontrados</caption>
        <thead><tr><th scope="col">Anúncio</th><th scope="col">Nota</th><th scope="col">Problemas</th></tr></thead>
        <tbody>
          @for (item of report.listings.qualityProblems; track item.itemId) {
          <tr><td>{{ item.title }}</td><td>{{ item.qualityScore }}/100</td><td>{{ item.issues.length }}</td></tr>
          }
        </tbody>
      </table>
    </div>
    <div>
      <span class="eyebrow">6. Publicidade</span>
      <h2>Ads no período</h2>
      @if (report.ads; as ads) {
      <div class="mini-kpis">
        <article><span>Gasto</span><strong>{{ formatMoney(ads.totals.cost) }}</strong></article>
        <article><span>Cliques</span><strong>{{ ads.totals.clicks }}</strong></article>
        <article><span>Vendas atribuídas</span><strong>{{ formatMoney(ads.totals.sales) }}</strong></article>
        <article><span>ROAS</span><strong>{{ ads.totals.roas | number : '1.2-2' }}x</strong></article>
      </div>
      } @else {
      <p class="muted">Sem dados de publicidade salvos para este período.</p>
      }
    </div>
  </section>

  @if (report.listings.hiddenGems.length > 0 || report.financial.topProfits.length > 0 || report.financial.topLosses.length > 0) {
  <section class="card section-card two-columns">
    <div>
      <span class="eyebrow">7. Joias escondidas</span>
      <h2>Boa conversão com pouco tráfego</h2>
      <table>
        <caption class="visually-hidden">Anúncios com boa conversão e pouco tráfego</caption>
        <thead><tr><th scope="col">Anúncio</th><th scope="col">Visitas</th><th scope="col">Vendas</th><th scope="col">Conv.</th></tr></thead>
        <tbody>
          @for (item of report.listings.hiddenGems; track item.itemId) {
          <tr><td>{{ item.title }}</td><td>{{ item.visits }}</td><td>{{ item.soldQuantityInPeriod }}</td><td>{{ formatPercent(item.conversionRate) }}</td></tr>
          }
        </tbody>
      </table>
    </div>
    <div>
      <span class="eyebrow">8. Financeiro por venda</span>
      <h2>Lucros e prejuízos</h2>
      <table>
        <caption class="visually-hidden">Vendas com lucro e prejuízo no período</caption>
        <thead><tr><th scope="col">Venda/produto</th><th scope="col">Recebido</th><th scope="col">Custos</th><th scope="col">Resultado</th></tr></thead>
        <tbody>
          @for (item of report.financial.topProfits; track item.operationKey) {
          <tr><td>{{ item.itemTitle || item.operationKey }}</td><td>{{ formatMoney(item.received) }}</td><td>{{ formatMoney(item.totalCosts) }}</td><td class="positive">{{ formatMoney(item.netResult) }}</td></tr>
          }
          @for (item of report.financial.topLosses; track item.operationKey) {
          <tr><td>{{ item.itemTitle || item.operationKey }}</td><td>{{ formatMoney(item.received) }}</td><td>{{ formatMoney(item.totalCosts) }}</td><td class="negative">{{ formatMoney(item.netResult) }}</td></tr>
          }
        </tbody>
      </table>
    </div>
  </section>
  }

  <section class="card section-card two-columns">
    <div>
      <span class="eyebrow">9. Caixa Mercado Pago</span>
      <h2>Dinheiro que entrou e saiu</h2>
      @if (report.cash; as cash) {
      <div class="mini-kpis">
        <article><span>Entrou</span><strong>{{ formatMoney(cash.entries) }}</strong></article>
        <article><span>Saiu</span><strong>{{ formatMoney(cash.exits) }}</strong></article>
        <article><span>Sobrou</span><strong>{{ formatMoney(cash.netCash) }}</strong></article>
        <article><span>Base comissão</span><strong>{{ formatMoney(cash.operationalNet) }}</strong></article>
      </div>
      } @else {
      <p class="muted">Sem extrato Account Money importado para este período.</p>
      }
    </div>
    <div>
      <span class="eyebrow">10. Campanhas e anúncios Ads</span>
      <h2>Onde a publicidade consumiu dinheiro</h2>
      @if (report.ads?.topAds?.length > 0) {
      <table>
        <caption class="visually-hidden">Anúncios de publicidade com gasto, vendas e ROAS</caption>
        <thead><tr><th scope="col">Anúncio</th><th scope="col">Gasto</th><th scope="col">Vendas</th><th scope="col">ROAS</th></tr></thead>
        <tbody>
          @for (item of report.ads.topAds; track item.id) {
          <tr><td>{{ item.title || item.name }}</td><td>{{ formatMoney(item.metrics.cost) }}</td><td>{{ formatMoney(item.metrics.sales) }}</td><td>{{ item.metrics.roas | number : '1.2-2' }}x</td></tr>
          }
        </tbody>
      </table>
      } @else {
      <p class="muted">Sem anúncios de publicidade salvos para o período. Atualize a aba Publicidade antes de emitir este relatório.</p>
      }
    </div>
  </section>

  <section class="card section-card">
    <span class="eyebrow">11. Todos os anúncios analisados</span>
    <h2>Lista operacional do período</h2>
    <p class="muted">Ordenado por faturamento, visitas e qualidade. Esta lista junta vendas do período com visitas retornadas pela API.</p>
    <table>
      <caption class="visually-hidden">Todos os anúncios analisados no relatório executivo</caption>
      <thead><tr><th scope="col">Anúncio</th><th scope="col">Visitas</th><th scope="col">Vendas</th><th scope="col">Faturou</th><th scope="col">Conv.</th><th scope="col">Nota</th><th scope="col">Problemas</th></tr></thead>
      <tbody>
        @for (item of report.listings.allListings; track item.itemId) {
        <tr>
          <td>{{ item.title }}</td>
          <td>{{ item.visits }}</td>
          <td>{{ item.soldQuantityInPeriod }}</td>
          <td>{{ formatMoney(item.grossRevenueInPeriod) }}</td>
          <td>{{ formatPercent(item.conversionRate) }}</td>
          <td>{{ item.qualityScore }}/100</td>
          <td>{{ item.issues.length }}</td>
        </tr>
        }
      </tbody>
    </table>
  </section>

  <section class="card section-card">
    <span class="eyebrow">12. Fontes e conferência técnica</span>
    <h2>De onde cada número veio</h2>
    <table>
      <caption class="visually-hidden">Fontes e endpoints usados no relatório executivo</caption>
      <thead><tr><th scope="col">Bloco do relatório</th><th scope="col">Endpoint/fonte</th><th scope="col">Status</th></tr></thead>
      <tbody>
        @for (row of report.endpointMap; track row.block) {
        <tr><td>{{ row.block }}</td><td>{{ row.endpoint }}</td><td>{{ row.status }}</td></tr>
        }
      </tbody>
    </table>
    <div class="limitations">
      @for (item of report.limitations; track item) { <p>{{ item }}</p> }
      @if (report.errors.length > 0) {
      <p class="error"><strong>Observações da coleta:</strong> {{ report.errors.length }} item(ns) tiveram falha de API. Abaixo estão os primeiros retornos para conferência.</p>
      @for (item of report.errors; track item) { <p class="error">{{ item }}</p> }
      }
    </div>
  </section>
  }
</main>
